import { Component, OnInit , ViewChild , ElementRef } from '@angular/core';
import { UrlHandlingStrategy } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { StatistiquesService } from 'src/app/Service/statistiques.service';
import * as _ from 'lodash';
import { SharedService } from 'src/app/Service/shared.service';
@Component({
  selector: 'app-statistiques-national',
  templateUrl: './statistiques-national.component.html',
  styleUrls: ['./statistiques-national.component.scss']
})
export class StatistiquesNationalComponent implements OnInit {

  constructor(private service:StatistiquesService, public global:Global, private shared: SharedService) {}
  bloc = {
    Titre: "",
    Contenu: ""
  }
  RapportsDeSynthese = [];
  StatistiquesTrim = [];
  StatistiquesAnnuel = [];
  SelectedRapportsDeSynthese = null;
  SelectedStatistiquesTrim = null;
  SelectedStatistiquesAnnuel = null;
  UrlRapportSynthese;
  UrlStatistiqueAnnuel;
  UrlStatistiqueTrim;
  DistinctYear = [];
  Selectedtrim = null;
  currentTrims = []
  SelectedYear;
  CurrentLink ='';

  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {

      this.RapportsDeSynthese = [];
      this.StatistiquesTrim = [];
      this.StatistiquesAnnuel = [];
       
      this.shared.getBlocDescriptionByCode(lg.url, "Statistiques-National").subscribe(data => {        
        this.bloc.Titre = data["value"][0] ? data["value"][0].Title : "";
        this.bloc.Contenu = data["value"][0] ? data["value"][0].Contenu : "";
      })

      // this.service.getStatistiqueAnnuelNational(this.global._basedUrl+ this.global._FrUrl).subscribe(datas=> {
      //     /* const obj = {
      //       Annee : 'Merci de saisir une année'
      //     }
      //     this.RapportsDeSynthese.push(obj); */
      //     datas["value"] = datas["value"].filter(item => typeof item['annee_x002d_stat_x002d_annuel'] === 'number').sort((a, b) => b['annee_x002d_stat_x002d_annuel'] - a['annee_x002d_stat_x002d_annuel'] );
      //     datas["value"].forEach(element => {            
      //       this.RapportsDeSynthese.push(element);
      //     });          
      //     this.SelectedRapportsDeSynthese = datas !== null  ? datas["value"][0].File.ServerRelativeUrl : null;
      //  }); 
       this.service.getStatistiqueTrimNational(this.global._basedUrl+ this.global._FrUrl).subscribe(datas=> {
          //datas["value"] = datas["value"].filter(item => typeof item['Annee'] === 'number').sort((a, b) => b['Annee'] - a['Annee'] );
          this.StatistiquesTrim = datas["value"];
          this.DistinctYear =  _.uniq(_.map(datas["value"], 'annee_trim'));
          this.currentTrims = this.DistinctYear.length > 0 ? this.changeYear(this.DistinctYear[0]): [];
          this.currentTrims = this.currentTrims.sort((a, b) => +b - +a );
          this.Selectedtrim =  this.currentTrims.length > 0 ? this.currentTrims[0] : null;
          this.CurrentLink = this.currentTrims.length > 0 ? this.currentTrims[0].File.ServerRelativeUrl : null;
          
          this.changetrim(this.CurrentLink) 
       });
       
       this.service.getStatistiqueAnnuelNational(this.global._basedUrl+ this.global._FrUrl).subscribe(datas=> {
        datas["value"] = datas["value"].filter(item => typeof item['annee_x002d_stat_x002d_annuel'] === 'number').sort((a, b) => b['annee_x002d_stat_x002d_annuel'] - a['annee_x002d_stat_x002d_annuel'] );
        datas["value"].forEach(element => {
          this.StatistiquesAnnuel.push(element);
        });        
        this.SelectedStatistiquesAnnuel = datas !== null  ? datas["value"][0].File.ServerRelativeUrl  : null;
      }); 
    });

  }
  DownloadTarget(target) {
    if(target)
    {
      target = this.global._baseUrlStatique + target;
      var redirect = window.open(target,'_blank');
      redirect.location;
    }
  }
  StatistiqueMonths(SelectedYear){
    return this.StatistiquesTrim.filter(element => element.Annee == SelectedYear.value);
  }
  changetrim(event) {
    // const link = document.getElementById('downloadReportM');
    // event !== null  ?link.setAttribute('href',this.global._baseUrlRacine + event ) : null;
    this.UrlStatistiqueTrim =  event !== null  ? event  : null;
  }
  changeYear(year) {
    
    this.currentTrims = this.StatistiquesTrim.filter(element => element.annee_trim == year);
    this.currentTrims = this.currentTrims .sort((a, b) => a['Num_x0020_trim'] - b['Num_x0020_trim']  );
    this.Selectedtrim=  this.currentTrims.length > 0 ? this.currentTrims[0] : null;
    console.log(this.Selectedtrim)
    this.CurrentLink = this.currentTrims.length > 0 ? this.currentTrims[0].File.ServerRelativeUrl : null;
    const result =this.StatistiquesTrim.filter(element => element.annee_trim == year);
    result.sort((a, b) => +b['Num_x0020_trim'] - +a['Num_x0020_trim'] );
      return  result
  }
  ChangeRapportDeSynthese(event){
    this.UrlRapportSynthese =  event !== null  ? this.global._baseUrlRacine + event  : null;
  }
  ChangeStatistiqueAnnuel(event){
    this.UrlStatistiqueAnnuel =  event !== null  ? this.global._baseUrlRacine + event  : null;
  }     
}
